// extracted by mini-css-extract-plugin
export default {"appChip":"AppChip_appChip__ivqUn","appInfo":"AppChip_appInfo__kfE0l","grey":"AppChip_grey__Bb4Bb"};